import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Group, Training } from '../app.types';
import { IonNav, ViewDidEnter } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronBack } from 'ionicons/icons';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrainingVideoPage } from '../training-video/training-video.page';
import { ApiService } from '../api.service';
import { Capacitor } from '@capacitor/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-training',
    templateUrl: './training.page.html',
    styleUrls: ['./training.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonNav
    ],
})
export class TrainingPage implements OnInit, ViewDidEnter {

    @ViewChild(IonNav) nav: IonNav
    @Input() t: Training

    //tid?: number
    embGroup: Group
    

    constructor(
        private api: ApiService,
        private meta: Meta,
        private title: Title
    ) {
        addIcons({ chevronBack })
    }

    ionViewDidEnter(): void {
        this.nav.push(TrainingVideoPage, {
            t: this.t,
            embGroup: this.embGroup
        })
    }

    ngOnInit() {
        // if (this.tid) {
        //     this.setupTraining(this.tid)
        // } 
    }

    async setupTraining(tid: number) {
        const tres = await this.api.getSingleTraining(tid)
        if (tres.trainings.length > 0) {
            this.t = tres.trainings[0]
            const tquests = await this.api.getTrainingQuest(this.t.tid)
            this.t.questions = tquests.questions

            const gres = await this.api.groupById(this.t.gid)
            this.embGroup = gres.group

            console.log("setupTraining", this.t.title, this.embGroup.name)

            

            if (!Capacitor.isNativePlatform()) {
                this.updateSeo()
            }

            this.nav.push(TrainingVideoPage, {
                t: this.t,
                embGroup: this.embGroup
            })

        }
    }

    updateSeo() {
        this.title.setTitle(this.t.title)
        this.meta.updateTag({
            name: "description",
            content: this.t.description
        })

        const mtags = [

            {
                property: "og:title",
                content: this.t.title
            },
            {
                property: "og:description",
                content: this.t.description
            },
            {
                property: "og:image",
                content: this.t.cover
            },
            {
                property: "og:url",
                content: "https://app.aitempo.online/embed/" + this.t.tid
            },
            {
                property: "og:type",
                content: "website"
            },
            {
                property: "og:site_name",
                content: "aiTempo"
            },
            {
                property: "twitter:card",
                content: "summary"
            },
            {
                property: "twitter:title",
                content: this.t.title
            },
            {
                property: "twitter:description",
                content: this.t.description
            },
            {
                property: "twitter:image",
                content: this.t.cover
            },
            {
                property: "twitter:url",
                content: "https://app.aitempo.online/embed/" + this.t.tid
            }
        ]
        for (const mt of mtags) {
            this.meta.updateTag({
                name: mt.property,
                content: mt.content
            })
        }
    }

    

    // ionViewWillEnter() {
    //     console.log(this.t)
    //     if (environment.trainingRedeem) {
    //         this.nav.push(TrainingResultPage, {
    //             t: this.t,
    //             result: {
    //                 accepted: true,
    //                 score: this.t.numQuest,
    //                 total: this.t.numQuest,
    //                 redeemCode: "lw76g746"
    //             }
    //         })
    //     } else {
    //         this.nav.push(TrainingVideoPage, {
    //             t: this.t
    //         })
    //     }


    // }



}
